// extracted by mini-css-extract-plugin
export default {"outer-wrapper":"styles_outer-wrapper__DI6a9","button":"styles_button__3FPNE","star":"styles_star__cwqoL","product-image-container":"styles_product-image-container__pjF2q"};